module.exports = __webpack_public_path__ + "static/pattern-bg-b08be6ad9068bbf22410087922f5cde0.png";